import { css } from "@emotion/react";
import { breakpoints, colors, fontSizes, gutterSizes, mediaQuery } from "../base/theme";

interface HintTooltipStyleProps {
    type?: string;
    wider?: boolean;
}

export const hintTooltipCss = ({ type, wider }: HintTooltipStyleProps) => css`
    &.hint-tooltip {
        position: relative;
        line-height: 1;

        &--color-base {
            .hint-tooltip-content {
                background: ${colors.blade10};
                color: ${colors.blade};

                &:before {
                    background: ${colors.blade10};
                }
            }
        }

        &--color-blue {
            .hint-tooltip-content {
                background: ${colors.fgInfo};
                color: ${colors.white};

                &:before {
                    background: ${colors.fgInfo};
                }
            }
        }

        &--color-white {
            .hint-tooltip-content {
                background: ${colors.white};
                color: ${colors.bark};
                filter: drop-shadow(0 0 12px rgba(0, 0, 0, 0.2));

                &:before {
                    background: ${colors.white};
                }
            }
        }

        .hint-tooltip-trigger {
            cursor: pointer;

            &--large {
                font-size: ${gutterSizes.large18};
            }

            &--small {
                font-size: 13px;
            }
        }

        .hint-tooltip-content {
            position: absolute;
            z-index: 3;
            width: ${type === 'Bark' ? '150px' : '285px'};
            transform: ${type === 'Bark' ? 'translate(calc(-50% + 8px), 15px)' : 'translateX(calc(-50% + 12px))'};
            padding: ${type === 'Bark' ? `${gutterSizes.small}  ${gutterSizes.base}` : gutterSizes.large};
            &--has-close-btn {
                padding-right: ${gutterSizes.xxlarge};
            }
            border-radius: 4px;
            line-height: 22px;
            
            ${type === 'Bark' && `
                font-size: ${fontSizes.small};
                color: ${colors.darkGrey};
            `}

            &:before {
                content: "";
                display: block;
                position: absolute;
                width: 12px;
                height: 12px;
                transform: rotate(45deg);
                top: -6px;
                left: calc(50% - 6px);
                border-radius: 2px;
            }

            .icon--clear {
                position: absolute;
                top: 12px;
                right: 12px;
                transform: none;
                min-width: auto;
            }

            &--left {
                transform: translateX(-44px);

                &:before {
                    left: 58px;
                }
            }

            &--right {
                transform: translateX(calc(-100% + 64px));

                &:before {
                    left: calc(100% - 58px);
                }
            }
        }

        ${mediaQuery.until(breakpoints.small)} {
            position: unset;

            .hint-tooltip-content {
                left: 50%;
                transform: translateX(-50%);
                width: ${wider ? '285px' : '230px'};

                &:before {
                    display: none;
                }
            }
        }

        .hint-tooltip-direction {
            &--top {
                top: -155px;
                padding: ${gutterSizes.large} ${gutterSizes.base};
                transform: ${type === 'Bark' ? 'translate(calc(-50% + 8px), 70px)' : 'translate(calc(-50% + 8px), 90px)'};

                ${mediaQuery.until(breakpoints.small)} {
                    left: 50%;
                    transform: ${type === 'Bark' ? 'translate(-50%, -250px)' : 'translateX(-50%)'};
                    top: 160px;

                    &:before {
                        display: block;
                    }
                }

                p {
                    color: ${colors.bark80};
                    margin: 0;
                }

                &:before {
                    bottom: -6px;
                    top: unset;
                }
            }
        }
    }
`;
